import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  pdf,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { useSelector } from "react-redux";
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
    fontSize: 12,
  },
  section: {
    flexGrow: 1,
  },
  titlesection: {
    backgroundColor: "#22798d",

    height: "50",
    padding: "10px",
  }, //#79cbe0
  addressSection: {
    backgroundColor: "#79cbe0",
    color: "#ffffff",
    height: "50",
    padding: "10px",
    display: "flex",
  },

  row: {
    display: "flex",
    flexDirection: "row",
  },
  column: {
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
  },
  column_nth_child_1: {
    alignItems: "flex-start",
  },
  column_nth_child_2: {
    alignItems: "center",
  },
  column_nth_child_3: {
    alignItems: "flex-end",
  },
  title: {
    fontSize: 24,
    color: "#ffffff",
  },

  document: {
    padding: 20,
  },
  table: {
    marginTop: "20px",
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#bfbfbf",
  },
  cell: {
    margin: "auto",
    fontSize: 12,
    padding: 8,
    borderStyle: "solid",

    width: 100, // Set the desired fixed width in pixels
  },

  gridCell: {
    backgroundColor: "#22798d",
    fontWeight: "bold",
    paddingTop: 8,
    paddingBottom: 8,

    width: 100,
  },
  evenRow: {
    backgroundColor: "#79cbe0",
  },
  oddRow: {
    backgroundColor: "#ffffff",
  },
});

const PdfFile = (rowData) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <View style={styles.titlesection}>
          <Text style={styles.title}>Company Name</Text>
        </View>
        <View style={styles.addressSection}>
          <View style={styles.row}>
            <Text style={styles.column}>onw</Text>
            <Text style={styles.column}>onw</Text>
            <Text style={styles.column}>onw</Text>
          </View>
        </View>
        <View style={styles.document}>
          <View style={styles.table}>
            <View style={styles.row}>
              <Text style={[styles.column, styles.gridCell]}> Date</Text>
              <Text style={[styles.column, styles.gridCell]}> Name</Text>
              <Text style={[styles.column, styles.gridCell]}>Item Name</Text>
              <Text style={[styles.column, styles.gridCell]}>Description</Text>
              <Text style={[styles.column, styles.gridCell]}>Item Qty</Text>
              <Text style={[styles.column, styles.gridCell]}>Unit Price</Text>
              <Text style={[styles.column, styles.gridCell]}>Discount</Text>
              <Text style={[styles.column, styles.gridCell]}>Amount</Text>
            </View>

            {rowData.rowData.map((row, index) => (
              <View
                key={index}
                style={[
                  styles.row,
                  (index + 1) % 2 === 0 ? styles.evenRow : styles.oddRow,
                ]}
              >
                <Text style={styles.cell}>{row.invoiceDate}</Text>
                <Text style={styles.cell}>{row.invoiceName}</Text>
                <Text style={styles.cell}>{row.itemName}</Text>
                <Text style={styles.cell}>{row.itemDescription}</Text>
                <Text style={styles.cell}>{row.itemQty}</Text>
                <Text style={styles.cell}>{row.unitPrice}</Text>
                <Text style={styles.cell}>{row.disPer}</Text>
                <Text style={styles.cell}>{row.amount}</Text>
              </View>
            ))}
          </View>
        </View>
      </View>
    </Page>
  </Document>
);

export default PdfFile;
